<template>
  <div id="app">
    <Main></Main>
  </div>
</template>

<script>
import Main from './components/Main.vue';

export default {
  name: 'App',
  components: {
    Main
  }
}
</script>

<style>
html,body{
  height: 100%;
  overflow: hidden;
}
body {
  padding: 0;
  margin: 0;
  text-align: center;
  background: #333;
  background-size: cover;
  /*font-family: 'Carter One', sans-serif;*/
  font-family: 'Karla';
}

.buttons > label, input[type=file], button {
  font-family: 'Carter One', sans-serif;
}

input, select {
  border: solid 1px #ddd;
  border-radius: 0.4rem;
}

a {
  color: darkblue;
  text-decoration: underline;
  cursor: pointer;
}

.attacker {
  color: red;
}

.defender {
  color: blue;
}

</style>
